angular.module('app.directives').directive('iframeOnload', [
    function () {
        return {
            scope: {
                callBack: '&iframeOnload'
            },
            link: function (scope, element) {
                element.on('load', function () {
                    scope.$apply(function () {
                        scope.callBack();
                    });
                });

                scope.$on('$destroy', function () {
                    element.off('load');
                });
            }
        };
    }
]);
